import { atom } from 'recoil';

export const needRefreshState = atom<string | boolean>({
  key: 'needRefreshState',
  default: false,
});
